import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector   : 'forms',
    templateUrl: './create.component.html',
    styleUrls  : ['./create.component.scss']
})
export class CreateComponent implements OnInit, OnDestroy
{
    responseLogin : any;
    stringResponseLogin: string;

    form: FormGroup;

    // Horizontal Stepper
    horizontalStepperStep1: FormGroup;
    horizontalStepperStep2: FormGroup;
    horizontalStepperStep3: FormGroup;

    // Vertical Stepper
    verticalStepperStep1: FormGroup;
    verticalStepperStep2: FormGroup;
    verticalStepperStep3: FormGroup;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _formBuilder: FormBuilder
    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();

        this.stringToJson();


        this.funcionConvert();

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Reactive Form
        this.form = this._formBuilder.group({
            company   : [
                {
                    value   : 'Google',
                    disabled: true
                }, Validators.required
            ],
            firstName : ['', Validators.required],
            lastName  : ['', Validators.required],
            address   : ['', Validators.required],
            address2  : ['', Validators.required],
            city      : ['', Validators.required],
            state     : ['', Validators.required],
            postalCode: ['', [Validators.required, Validators.maxLength(5)]],
            country   : ['', Validators.required]
        });

        // Horizontal Stepper form steps
        this.horizontalStepperStep1 = this._formBuilder.group({
            firstName: ['', Validators.required],
            lastName : ['', Validators.required]
        });

        this.horizontalStepperStep2 = this._formBuilder.group({
            address: ['', Validators.required]
        });

        this.horizontalStepperStep3 = this._formBuilder.group({
            city      : ['', Validators.required],
            state     : ['', Validators.required],
            postalCode: ['', [Validators.required, Validators.maxLength(5)]]
        });

        // Vertical Stepper form stepper
        this.verticalStepperStep1 = this._formBuilder.group({
            firstName: ['', Validators.required],
            lastName : ['', Validators.required]
        });

        this.verticalStepperStep2 = this._formBuilder.group({
            address: ['', Validators.required]
        });

        this.verticalStepperStep3 = this._formBuilder.group({
            city      : ['', Validators.required],
            state     : ['', Validators.required],
            postalCode: ['', [Validators.required, Validators.maxLength(5)]]
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Finish the horizontal stepper
     */
    finishHorizontalStepper(): void
    {
        alert('You have finished the horizontal stepper!');
    }

    /**
     * Finish the vertical stepper
     */
    finishVerticalStepper(): void
    {
        alert('You have finished the vertical stepper!');
    }

    updateJson(event,expression){
      /*
      var json2 = jsonIdioma.jsonEncuesta.replace(/replace1/g, urlCompleta).replace(/replace2/g, empresa.datosEmpresa.nombreEmpresa);
      */
      //var json2 = jsonIdioma.jsonEncuesta.replace(/"/g, '\"');
      switch(expression) {
        case 1:
          // code block
          this.responseLogin['gptw']['logo'] = event.target.value;
          //console.log(JSON.stringify(this.responseLogin));
          this.stringResponseLogin = JSON.stringify(this.responseLogin).replace(/"/g, '\"');
          break;
        case 2:
          // code block
          this.responseLogin['gptw']['name'] = event.target.value;
          //console.log(JSON.stringify(this.responseLogin));
          this.stringResponseLogin = JSON.stringify(this.responseLogin).replace(/"/g, '\"');
          break;
        case 3:
          // code block
          this.responseLogin['screen']['screenName'] = event.target.value;
          //console.log(JSON.stringify(this.responseLogin));
          this.stringResponseLogin = JSON.stringify(this.responseLogin).replace(/"/g, '\"');
          break;
        case 4:
          // code block
          this.responseLogin['screen']['customContent']['languageSelection'] = event.target.value;
          //console.log(JSON.stringify(this.responseLogin));
          this.stringResponseLogin = JSON.stringify(this.responseLogin).replace(/"/g, '\"');
          break;
        case 5:
          // code block
          this.responseLogin['screen']['customContent']['msgAccess'] = event.target.value;
          //console.log(JSON.stringify(this.responseLogin));
          this.stringResponseLogin = JSON.stringify(this.responseLogin).replace(/"/g, '\"');
          break;
        case 6:
          // code block
          this.responseLogin['screen']['customContent']['text'] = event.target.value;
          //console.log(JSON.stringify(this.responseLogin));
          this.stringResponseLogin = JSON.stringify(this.responseLogin).replace(/"/g, '\"');
          break;
        case 7:
          // code block
          this.responseLogin['screen']['customContent']['inputPlaceHolderUser'] = event.target.value;
          //console.log(JSON.stringify(this.responseLogin));
          this.stringResponseLogin = JSON.stringify(this.responseLogin).replace(/"/g, '\"');
          break;
        case 8:
          // code block
          this.responseLogin['screen']['customContent']['inputPlaceHolderPass'] = event.target.value;
          //console.log(JSON.stringify(this.responseLogin));
          this.stringResponseLogin = JSON.stringify(this.responseLogin).replace(/"/g, '\"');
          break;
        case 9:
          // code block
          this.responseLogin['screen']['customContent']['buttons']['login']['label'] = event.target.value;
          //console.log(JSON.stringify(this.responseLogin));
          this.stringResponseLogin = JSON.stringify(this.responseLogin).replace(/"/g, '\"');
          break;
        default:
          break;
          // code block

      }
    }

    funcionConvert(){
      let data = {
    "gptw": {
        "logo": "../assets/images/logo/logoGPTW2.png",
        "name": "Great Place To Work (r) 2019"
    },
    "screens": [
        {
            "screenId": 1,
            "screenName": "Bienvenido",
            "customContent": {
                "buttons": {
                    "next": {
                        "label": "Siguiente"
                    }
                },
                "header": {
                    "logo": "../assets/images/logo/logo1.png",
                    "title": "Great Place to Work® Survey 2019"
                },
                "text": "<h1><b>Bienvenido</b></h1><br><video controls autoplay><source src=../assets/media/video1_es.mp4 type=video/mp4></source></video>"
            },
            "windowLogout": {
                "title": "La encuesta no ha sido iniciada",
                "text": "<p>La encuesta no ha sido iniciada. <br> <b>Cancelar</b> para continuar. <br> <b>Salir</b> para salir de la encuesta.</p>",
                "buttons": {
                    "logout": "Cerrar sesión",
                    "cancel": "Cancelar"
                }
            }
        },
        {
            "screenId": 2,
            "screenName": "Instrucciones",
            "customContent": {
                "buttons": {
                    "previous": {
                        "label": "Anterior"
                    },
                    "start": {
                        "label": "Inicio"
                    },
                    "continue": {
                        "label": "Continuar"
                    }
                },
                "header": {
                    "title": "Great Place to Work® Survey 2019"
                },
                "text": "<p><h3><b>Instrucciones de encuesta</b></h3><br>Gracias por participar en Great Place to Work.<sup>&reg;</sup> Encuesta. Esta encuesta está diseñada para brindarle la oportunidad de decirnos cómo se siente con respecto a su experiencia laboral. Tendrá la oportunidad de evaluar tanto su trabajo como la organización general como un lugar para trabajar en una variedad de áreas. Hacia el final de la encuesta, también tiene la oportunidad de compartir sus puntos de vista personales sobre lo que hace que su organización sea un excelente lugar para trabajar, y sus sugerencias para mejorar.<br><br>The Great Place to Work<sup></sup> La encuesta requiere respuestas de doble perspectiva de usted. <br> <b>Para cada declaración, debe proporcionar dos respuestas: por Grupo de trabajo y por Organización.</b><br><br>  <b>Grupo de trabajo</b>  se refiere a su experiencia dentro de su división<br><b>Organización</b>  se refiere a su experiencia general trabajando en SSG<br> <b>Administración</b> debajo <b>Grupo de trabajo</b>  debajo Grupo de trabajo se refiere a su oficial de informes / líder de equipo<b><br>Administración</b> debajo <b>Organización</b> debajo Organización se refiere a los directores y arriba <br><br>Le tomará aproximadamente 15 minutos completar la encuesta. <br> Idealmente, debe completar la encuesta en un solo asiento, pero si no puede hacerlo, sus respuestas se guardarán automáticamente antes de cerrar la sesión. <br><br>Una vez que haya completado su encuesta, revise sus respuestas y luego haga clic en <b>Enviar</b>.<br>Tenga en cuenta que las encuestas enviadas no se pueden volver a abrir; y las encuestas no enviadas no se contarán.<br><br>Si tiene alguna pregunta o encuentra algún problema técnico al completar la encuesta, comuníquese con Great Place to Work<sup></sup> a support-sg@gptwonline.com.<br>SkillsFuture Singapore se compromete a brindarle una mejor experiencia en el lugar de trabajo.</p>"
            },
            "windowLogout": {
                "title": "La encuesta no ha sido iniciada",
                "text": "<p>La encuesta no ha sido iniciada. <br> <b>Cancelar</b> para continuar. <br> <b>Salir</b> para salir de la encuesta.</p>",
                "buttons": {
                    "logout": "Cerrar sesión",
                    "cancel": "Cancelar"
                }
            }
        },
        {
            "screenId": 3,
            "screenName": "Survey",
            "customContent": {
                "generics": {
                    "requiredText": "* Esta pregunta es requerida."
                },
                "bandRequired": {
                    "active": false
                },
                "header": {
                    "logo": "../assets/images/logo/logo1.png",
                    "title": "Great Place to Work® Survey 2019"
                },
                "instructions": {
                    "active": true,
                    "text": "<p> <h3> Instrucciones de la encuesta </h3> <br> Gracias por participar en la Encuesta Great Place to Work®. Esta encuesta está diseñada para brindarle la oportunidad de decirnos cómo se siente con respecto a su experiencia laboral. Tendrá la oportunidad de evaluar tanto su trabajo como la organización general como un lugar para trabajar en una variedad de áreas. Hacia el final de la encuesta, también tiene la oportunidad de compartir sus puntos de vista personales sobre lo que hace que su organización sea un excelente lugar para trabajar, y sus sugerencias para mejoras. <br> <br> Encuesta The Great Place to Work® requiere respuestas de doble perspectiva de usted. <b> Para cada declaración, debe proporcionar dos respuestas: por Grupo de trabajo y por Organización. </b> Verifique sus respuestas en función de su experiencia utilizando las siguientes definiciones: <br> <br> <b> Grupo de trabajo </b> se refiere a su experiencia dentro de su departamento <br> <b> Organización </b> se refiere a su experiencia general trabajando en su organización <br> <b> Administración </b> en <b> Grupo de trabajo </b> se refiere a su supervisor / gerente directo <br> <b> Administración </b> en <b> Organización </b> se refiere a su organización alta gerencia <br> <br> El período de administración de la encuesta es del 01 de marzo de 2019 al 4 de marzo de 2019. Le tomará aproximadamente 15 minutos completar la encuesta. Idealmente, debe completar la encuesta de una vez, pero si no puede hacerlo, haga clic en <b> Guardar y salir </b> para abandonar la encuesta. Se le dirigirá a donde se fue la próxima vez que inicie sesión. Una vez hecho esto, revise sus respuestas y luego haga clic en <b> Enviar. </b> Tenga en cuenta que las encuestas enviadas no se pueden volver a abrir; y las encuestas no enviadas no se pueden contar. Si tiene alguna pregunta o encuentra algún problema técnico al responder la encuesta, comuníquese con [la persona de contacto del Equipo de Proyecto de la Compañía] en [dirección de correo electrónico]. </b> <br> ABC Company se compromete a brindarle una mejor experiencia en el lugar de trabajo. Por lo tanto, sus comentarios son importantes para nosotros. Gracias por tomarse el tiempo para responder la encuesta. </p>",
                    "button": {
                        "label": "Instrucciones"
                    }
                },
                "definitions": {
                    "active": true,
                    "text": "<p> <h3> Definiciones de la encuesta </h3> La encuesta Great Place to Work® requiere respuestas de doble perspectiva por su parte. <b> Para cada declaración, debe proporcionar dos respuestas: por Grupo de trabajo y por Organización. </b> <br> Verifique sus respuestas en función de su experiencia utilizando las siguientes definiciones: <br><br> <b> Grupo de trabajo </b> se refiere a su experiencia dentro de su departamento <br> <b> Organización </b> se refiere a su experiencia general trabajando en su organización <br> <b> Administración </b> bajo <b> Grupo de trabajo </b> se refiere a su supervisor / gerente directo <br><br><b> Administración </b> bajo <b>Organización</b> se refiere a la alta gerencia de su organización <br/> </p>",
                    "button": {
                        "label": "Definiciones"
                    }
                },
                "reactive": {
                    "cssId": 0,
                    "organization": {
                        "title": "Perspectiva de Organización ",
                        "tooltip": {
                            "text": "<b> Organización </b> se refiere a su experiencia general trabajando en su organización. <br> <b> Administración</b> en Organización se refiere a la alta gerencia de su organización",
                            "active": true
                        }
                    },
                    "workgroup": {
                        "title": "Perspectiva de Área",
                        "tooltip": {
                            "text": "<b> Grupo de trabajo </b> se refiere a su experiencia dentro de su departamento. <br> <b> Gestión </b> en <b> Grupo de trabajo </b> se refiere a su supervisor / gerente directo",
                            "active": true
                        }
                    }
                },
                "pagination": {
                    "buttons": {
                        "next": "Siguiente",
                        "previous": "Anterior",
                        "finish": "Finalizar"
                    }
                },
                "windowFinish": {
                    "title": "Finalizar encuesta",
                    "text": "<p> Ya ha respondido todas las preguntas de la encuesta. <br> <br> Para enviar su encuesta, haga clic en <b>Enviar</b> </p>.",
                    "buttons": {
                        "close": "Enviar"
                    }
                },
                "windowFinishMessage": {
                    "title": "¡Respuestas Completas!",
                    "text": "Ha completado con éxito la encuesta.<br> <br><b>¡Gracias por participar!</b>",
                    "buttons": {
                        "close": "Enviar"
                    }
                }
            },
            "windowLogout": {
                "title": "¡Respuestas incompletas!",
                "text": "<p> Todavía no ha respondido todas las preguntas de la encuesta. <br> Las preguntas omitidas se han marcado con un sombreado rojo. <br> Para volver a la encuesta, haga clic en <b> Anterior </b> . <br> Para guardar y continuar más tarde, haga clic en <b> Guardar y salir </b>.<br>Para enviar su encuesta </p>.",
                "buttons": {
                    "saveAndExit": "Guardar y Salir",
                    "previous": "Anterior",
                    "logout": "Cerrar sesión"
                }
            },
            "windowLogoutMessage": {
                "title": "¡Respuestas incompletas!",
                "text": "No ha terminado de responder la encuesta.<br><br><b>¡Esperamos que vuelva pronto!</b>",
                "buttons": {
                    "close": "Enviar"
                }
            }
        }
    ],
    "generics": {
        "buttons": {
            "logout": "Cerrar sesión"
        }
    }

}
    console.log(JSON.stringify(data));
    }

    stringToJson(){
      var cadenaLogin = "{\"gptw\":{\"logo\":\"../assets/images/logo/logoGPTW2.png\",\"name\":\"Great Place To Work (r) 2019\"},\"screen\":{\"screenId\":1,\"screenName\":\"Login\",\"customContent\":{\"languageSelection\":\"Seleccione idioma\",\"msgAccess\":\"Acceso\",\"text\":\"<br><p>Welcome to the NewCorp Great Place to Work<sup>®</sup> Survey.</p><p>Esta encuesta está diseñada para brindarle la oportunidad de decirnos cómo se siente acerca de su experiencia en el lugar de trabajo. <br> Tendrá la oportunidad de evaluar tanto su trabajo como la organización general como un lugar para trabajar en una variedad de áreas.</p><p>Hacia el final de la encuesta, también tiene la oportunidad de compartir sus puntos de vista personales sobre lo que hace que su organización sea un excelente lugar para trabajar y sus sugerencias para mejorar.</p><p> </p><p>The Great Place to Work<sup>®</sup> La encuesta requiere respuestas de doble perspectiva de usted.</p><p><strong>Para cada declaración, debe proporcionar 2 respuestas: por ‘Grupo de trabajo’ y por ‘Organización’</strong>.</p><p>Verifique sus respuestas en función de su experiencia utilizando las siguientes definiciones:</p><p> </p><p><strong>‘Grupo de trabajo’</strong> se refiere a su experiencia dentro de su división<br><strong>‘Organización’</strong> se refiere a su experiencia general trabajando en NewCorp<br><strong>‘Administración’</strong> under <strong>‘Grupo de trabajo’</strong> se refiere a su oficial de informes / líder de equipo<br><strong>‘Administración’</strong> debajo<strong>‘Organización’</strong> se refiere a los directores y arriba</p><br>\",\"inputPlaceHolderUser\":\"Usuario\",\"inputPlaceHolderPass\":\"Contraseña\",\"buttons\":{\"login\":{\"label\":\"Inicio\"}}}}}";

      let jsonLogin = JSON.parse(cadenaLogin);

      this.responseLogin = jsonLogin;


      var cadenaConfiguracion = "{\"gptw\":{\"logo\":\"../assets/images/logo/logoGPTW2.png\",\"name\":\"Great Place To Work (r) 2019\"},\"screens\":[{\"screenId\":1,\"screenName\":\"Bienvenido\",\"customContent\":{\"buttons\":{\"next\":{\"label\":\"Siguiente\"}},\"header\":{\"logo\":\"replace1\",\"title\":\"replace2\"},\"text\":\"<h1><b>Bienvenido</b></h1><br/><iframe class=embed-responsive-item src=../assets/media/video1.mp4></iframe>\"}},{\"screenId\":2,\"screenName\":\"Instrucciones\",\"customContent\":{\"buttons\":{\"previous\":{\"label\":\"Anterior\"},\"start\":{\"label\":\"Inicio\"},\"continue\":{\"label\":\"Continuar\"}},\"header\":{\"title\":\"replace2\"},\"text\":\"<p><h3><b>Instrucciones de encuesta</b></h3><br/>Gracias por participar en Great Place to Work.<sup>&reg;</sup> Encuesta. Esta encuesta está diseñada para brindarle la oportunidad de decirnos cómo se siente con respecto a su experiencia laboral. Tendrá la oportunidad de evaluar tanto su trabajo como la organización general como un lugar para trabajar en una variedad de áreas. Hacia el final de la encuesta, también tiene la oportunidad de compartir sus puntos de vista personales sobre lo que hace que su organización sea un excelente lugar para trabajar, y sus sugerencias para mejorar.<br/><br/>The Great Place to Work<sup></sup> La encuesta requiere respuestas de doble perspectiva de usted. <br/> <b>Para cada declaración, debe proporcionar dos respuestas: por Grupo de trabajo y por Organización.</b><br/><br/>  <b>Grupo de trabajo</b>  se refiere a su experiencia dentro de su división<br/><b>Organización</b>  se refiere a su experiencia general trabajando en SSG<br/> <b>Administración</b> debajo <b>Grupo de trabajo</b>  debajo Grupo de trabajo se refiere a su oficial de informes / líder de equipo<b><br/>Administración</b> debajo <b>Organización</b> debajo Organización se refiere a los directores y arriba <br/><br/>Le tomará aproximadamente 15 minutos completar la encuesta. </br> Idealmente, debe completar la encuesta en un solo asiento, pero si no puede hacerlo, sus respuestas se guardarán automáticamente antes de cerrar la sesión. </br></br>Una vez que haya completado su encuesta, revise sus respuestas y luego haga clic en <b>Enviar</b>.</br>Tenga en cuenta que las encuestas enviadas no se pueden volver a abrir; y las encuestas no enviadas no se contarán.</br></br>Si tiene alguna pregunta o encuentra algún problema técnico al completar la encuesta, comuníquese con Great Place to Work<sup></sup> a support-sg@gptwonline.com.</br>SkillsFuture Singapore se compromete a brindarle una mejor experiencia en el lugar de trabajo.</p>\"}},{\"screenId\":3,\"screenName\":\"Survey\",\"customContent\":{\"generics\":{\"requiredText\":\"* Esta pregunta es requerida.\"},\"bandRequired\":{\"active\":true,\"text\":\"* Esta pregunta es requerida.\"},\"header\":{\"logo\":\"replace1\",\"title\":\"replace2\"},\"instructions\":{\"active\":true,\"text\":\"<p> <h3> Instrucciones de la encuesta </h3> <br/> Gracias por participar en la Encuesta Great Place to Work®. Esta encuesta está diseñada para brindarle la oportunidad de decirnos cómo se siente con respecto a su experiencia laboral. Tendrá la oportunidad de evaluar tanto su trabajo como la organización general como un lugar para trabajar en una variedad de áreas. Hacia el final de la encuesta, también tiene la oportunidad de compartir sus puntos de vista personales sobre lo que hace que su organización sea un excelente lugar para trabajar, y sus sugerencias para mejoras. <br/> <br/> Encuesta The Great Place to Work® requiere respuestas de doble perspectiva de usted. <b> Para cada declaración, debe proporcionar dos respuestas: por Grupo de trabajo y por Organización. </b> Verifique sus respuestas en función de su experiencia utilizando las siguientes definiciones: <br/> <br/> <b> Grupo de trabajo </b> se refiere a su experiencia dentro de su departamento <br/> <b> Organización </b> se refiere a su experiencia general trabajando en su organización <br/> <b> Administración </b> en <b> Grupo de trabajo </b> se refiere a su supervisor / gerente directo <br/> <b> Administración </b> en <b> Organización </b> se refiere a su organización alta gerencia <br/> <br/> El período de administración de la encuesta es del 01 de marzo de 2019 al 4 de marzo de 2019. Le tomará aproximadamente 15 minutos completar la encuesta. Idealmente, debe completar la encuesta de una vez, pero si no puede hacerlo, haga clic en <b> Guardar y salir </b> para abandonar la encuesta. Se le dirigirá a donde se fue la próxima vez que inicie sesión. Una vez hecho esto, revise sus respuestas y luego haga clic en <b> Enviar. </b> Tenga en cuenta que las encuestas enviadas no se pueden volver a abrir; y las encuestas no enviadas no se pueden contar. Si tiene alguna pregunta o encuentra algún problema técnico al responder la encuesta, comuníquese con [la persona de contacto del Equipo de Proyecto de la Compañía] en [dirección de correo electrónico]. </b> <br/> ABC Company se compromete a brindarle una mejor experiencia en el lugar de trabajo. Por lo tanto, sus comentarios son importantes para nosotros. Gracias por tomarse el tiempo para responder la encuesta. </p>\",\"button\":{\"label\":\"Instrucciones\"}},\"definitions\":{\"active\":true,\"text\":\"<p> <h3> Definiciones de la encuesta </h3> La encuesta Great Place to Work® requiere respuestas de doble perspectiva por su parte. <b> Para cada declaración, debe proporcionar dos respuestas: por Grupo de trabajo y por Organización. </b> <br/> Verifique sus respuestas en función de su experiencia utilizando las siguientes definiciones: <br/> <br/> <b> Grupo de trabajo </b> se refiere a su experiencia dentro de su departamento <br/> <b> Organización </b> se refiere a su experiencia general trabajando en su organización <br/> <b> Administración </b> bajo <b> Grupo de trabajo </b> se refiere a su supervisor / gerente directo <br/> <br/> <b> Administración </b> bajo <b>Organización</b> se refiere a la alta gerencia de su organización <br/> </p>\",\"button\":{\"label\":\"Definiciones\"}},\"reactive\":{\"organization\":{\"title\":\"Organización\",\"tooltip\":{\"text\":\"<b> Organización </b> se refiere a su experiencia general trabajando en su organización. </br> <b> Administración</b> en Organización se refiere a la alta gerencia de su organización\",\"active\":true}},\"workgroup\":{\"title\":\"Área\",\"tooltip\":{\"text\":\"<b> Grupo de trabajo </b> se refiere a su experiencia dentro de su departamento. </br> <b> Gestión </b> en <b> Grupo de trabajo </b> se refiere a su supervisor / gerente directo\",\"active\":true}}},\"pagination\":{\"buttons\":{\"next\":\"Siguiente\",\"previous\":\"Anterior\",\"finish\":\"Finalizar\"}}}},{\"screenId\":4,\"screenName\":\"logout\",\"customContent\":{\"header\":{\"logo\":\"replace1\",\"title\":\"replace2\"},\"logout\":[{\"type\":1,\"message\":\"Ha completado con éxito la encuesta.<br/> <br/><b>¡Gracias por participar!</b>\"},{\"type\":2,\"message\":\"No ha terminado de responder la encuesta.</br></br><b>¡Esperamos que vuelva pronto!</b>\"}]}}],\"windowLogout\":{\"title\":\"¡Respuestas incompletas!\",\"text\":\"<p> Todavía no ha respondido todas las preguntas de la encuesta. <br/> Las preguntas omitidas se han marcado con un sombreado rojo. <br/> Para volver a la encuesta, haga clic en <b> Anterior </b> . <br/> Para guardar y continuar más tarde, haga clic en <b> Guardar y salir </b>. <br/> Para enviar su encuesta </p>.\",\"buttons\":{\"saveAndExit\":\"Guardar y Salir\",\"previous\":\"Anterior\",\"logout\":\"Cerrar sesión\"}},\"windowFinish\":{\"title\":\"Finalizar encuesta\",\"text\":\"<p> Ya ha respondido todas las preguntas de la encuesta. <br/> <br/> Para enviar su encuesta, haga clic en <b>Enviar</b> </p>.\",\"buttons\":{\"close\":\"Enviar\"}}}";

      let jsonConfiguracion = JSON.parse(cadenaConfiguracion);

      //console.log(JSON.stringify(jsonConfiguracion));


      var ejemplo = "{\"gptw\":{\"logo\":\"deedededed\",\"name\":\"dededededed\"},\"screen\":{\"screenId\":1,\"screenName\":\"dedededegg\",\"customContent\":{\"languageSelection\":\"gggg\",\"msgAccess\":\"ggg\",\"text\":\"gggggggg\",\"inputPlaceHolderUser\":\"g\",\"inputPlaceHolderPass\":\"g\",\"buttons\":{\"login\":{\"label\":\"gxasasasasaszasazzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzqqqq\"}}}}}";


      var data = "{\"gptw\":{\"logo\":\"../assets/images/logo/logoGPTW2.png\",\"name\":\"Great Place To Work (r) 2019\"},\"screen\":{\"screenId\":1,\"screenName\":\"Login\",\"customContent\":{\"languageSelection\":\"Seleccione idioma\",\"msgAccess\":\"Acceso\",\"text\":\"<br><p>Welcome to the NewCorp Great Place to Work<sup>®</sup> Survey.</p><p>Esta encuesta está diseñada para brindarle la oportunidad de decirnos cómo se siente acerca de su experiencia en el lugar de trabajo. <br> Tendrá la oportunidad de evaluar tanto su trabajo como la organización general como un lugar para trabajar en una variedad de áreas.</p><p>Hacia el final de la encuesta, también tiene la oportunidad de compartir sus puntos de vista personales sobre lo que hace que su organización sea un excelente lugar para trabajar y sus sugerencias para mejorar.</p><p> </p><p>The Great Place to Work<sup>®</sup> La encuesta requiere respuestas de doble perspectiva de usted.</p><p><strong>Para cada declaración, debe proporcionar 2 respuestas: por ‘Grupo de trabajo’ y por ‘Organización’</strong>.</p><p>Verifique sus respuestas en función de su experiencia utilizando las siguientes definiciones:</p><p> </p><p><strong>‘Grupo de trabajo’</strong> se refiere a su experiencia dentro de su división<br><strong>‘Organización’</strong> se refiere a su experiencia general trabajando en NewCorp<br><strong>‘Administración’</strong> under <strong>‘Grupo de trabajo’</strong> se refiere a su oficial de informes / líder de equipo<br><strong>‘Administración’</strong> debajo<strong>‘Organización’</strong> se refiere a los directores y arriba</p><br>\",\"inputPlaceHolderUser\":\"Usuario\",\"inputPlaceHolderPass\":\"Contraseña\",\"buttons\":{\"login\":{\"label\":\"Inicio\"}}}}}";


    }

}
